import * as React from 'react'

interface ToolbarContextState {
  isDirty: boolean
  setIsDirty: (bool: boolean) => void
  reRun: boolean
  setReRun: (a: boolean) => void
  loadingProgress: boolean
  setToolbarLoadingProgress: (bool: boolean) => void
  expanded: boolean
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>
  children: React.ReactNode
}

const initialState: ToolbarContextState = {
  isDirty: false,
  setIsDirty: (a: boolean) => {},
  reRun: false,
  setReRun: (a: boolean) => {},
  loadingProgress: false,
  setToolbarLoadingProgress: (a: boolean) => {},
  expanded: false,
  setExpanded: () => {},
  children: null,
}

const ToolbarContext = React.createContext<ToolbarContextState>(initialState)

function ToolbarContextProvider({children}: {children: React.ReactNode}) {
  const [expanded, setExpanded] = React.useState<boolean>(initialState.expanded)
  const [loadingProgress, setToolbarLoadingProgress] = React.useState<boolean>(
    initialState.loadingProgress
  )
  const [reRun, setReRun] = React.useState<boolean>(initialState.reRun)
  const [isDirty, setIsDirty] = React.useState<boolean>(initialState.isDirty)

  return (
    <ToolbarContext.Provider
      value={{
        isDirty,
        setIsDirty,
        reRun,
        setReRun,
        loadingProgress,
        setToolbarLoadingProgress,
        expanded,
        setExpanded,
        children,
      }}
    >
      {children}
    </ToolbarContext.Provider>
  )
}

export const useToolbarContext = (): ToolbarContextState => React.useContext(ToolbarContext)

export default function ToolbarProvider({children}: {children: React.ReactNode}) {
  return <ToolbarContextProvider>{children}</ToolbarContextProvider>
}
